<template>
  <div class="mapbox">
    <div v-if="detailType === 'overview'" class="chart-area">
      <div class="closebtn" @click="$emit('closeDetail')">关闭 ×</div>
      <div class="header">产业数据</div>

      <div class="chart-items">
        <!-- 图1：养殖面积及增速 -->
        <div class="chart">
          <div ref="chart1" style="width: 100%; height: 100%"></div>
        </div>

        <!-- 图3：产量加工量占比 -->
        <div class="chart">
          <div ref="chart3" style="width: 100%; height: 100%"></div>
        </div>

        <!-- 图2：滚动表格 -->
        <div class="chart">
          <div class="table-wrap">
            <div class="table-title">2024年各省（区、市）小龙虾养殖产量（单位：吨）</div>
            <dv-scroll-board
              :config="config2"
              class="overview-table"
              style="width: 100%; flex: 1; min-height: 0" />
          </div>
        </div>

        <div class="chart">
          <div class="table-wrap">
            <div class="table-title">2024年小龙虾产量超3万吨的县市区（单位：万吨）</div>
            <dv-scroll-board
              :config="config4"
              class="overview-table"
              style="width: 100%; flex: 1; min-height: 0" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="detailType === 'gathering'" class="chart-area">
      <div class="closebtn" @click="$emit('closeDetail')">关闭 ×</div>
      <div class="header">集货点图片</div>
      <div class="gathering-content">
        <img v-for="(img, i) in images" :key="i" :src="img" class="img-item" />
      </div>
    </div>

    <div v-show="detailType === 'farmerData'" class="chart-area">
      <!-- 黄梅县农户数据 -->
      <template v-if="activePage == 1">
        <div class="closebtn" @click="$emit('closeDetail')">关闭 ×</div>
        <div class="header">{{ townTitle }}</div>
        <div v-if="loading" class="loading">
          <img src="@/assets/images/loading.gif" alt="加载中..." />
        </div>
        <div class="farmer-content">
          <dv-scroll-board
            :config="townData"
            class="farmer-table"
            @click="handleClickTown"
            style="width: 100%; height: 100%; cursor: pointer; font-size: 18px" />
        </div>
      </template>

      <template v-if="activePage == 2">
        <div class="btns">
          <div class="goback" @click="activePage--">◀ 返回</div>
          <div class="closebtn" @click="$emit('closeDetail')">关闭 ×</div>
        </div>
        <div class="header">{{ currentTownTitle }}</div>
        <div v-if="loading" class="loading">
          <img src="@/assets/images/loading.gif" alt="加载中..." />
        </div>
        <div class="farmer-content">
          <dv-scroll-board
            :config="currentTownData"
            class="farmer-table"
            @click="handleClickVillage"
            style="width: 100%; height: 100%; cursor: pointer" />
        </div>
      </template>

      <template v-if="activePage == 3">
        <div class="btns">
          <div class="goback" @click="activePage--">◀ 返回</div>
          <div class="closebtn" @click="$emit('closeDetail')">关闭 ×</div>
        </div>
        <div class="header">{{ currentVillageTitle }}</div>
        <div v-if="loading" class="loading">
          <img src="@/assets/images/loading.gif" alt="加载中..." />
        </div>
        <div class="farmer-content">
          <dv-scroll-board
            :config="currentVillageData"
            class="farmer-table"
            style="width: 100%; height: 100%" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getTownData, getVillageData } from '@/api/getData'
import * as echarts from 'echarts'
import { mapGetters } from 'vuex'

const years = ['2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024']

export default {
  name: 'IndustryDetail',

  props: {
    detailType: {
      type: String,
      default: 'overview'
    }
  },

  data() {
    return {
      chart1Instance: null,
      chart3Instance: null,

      config2: {
        header: ['排序', '省份', '产量(吨)'],
        data: [
          ['1', '湖北', '1,437,321'],
          ['2', '安徽', '672,037'],
          ['3', '湖南', '482,246'],
          ['4', '江苏', '292,217'],
          ['5', '江西', '234,592'],
          ['6', '四川', '104,175'],
          ['7', '山东', '63,944'],
          ['8', '河南', '50,702'],
          ['9', '浙江', '50,352'],
          ['10', '广西', '23,028'],
          ['11', '重庆', '19,898'],
          ['12', '云南', '3,444'],
          ['13', '广东', '3,317'],
          ['14', '福建', '2,554'],
          ['15', '陕西', '2,506'],
          ['16', '贵州', '1,940'],
          ['17', '新疆', '991'],
          ['18', '黑龙江', '727'],
          ['19', '辽宁', '620'],
          ['20', '海南', '344'],
          ['21', '山西', '329'],
          ['22', '上海', '232'],
          ['23', '吉林', '34'],
          ['24', '内蒙古', '15'],
          ['25', '河北', '8'],
          ['26', '甘肃', '4'],
          ['27', '宁夏', '1']
        ],
        rowNum: 8,
        headerHeight: 35,
        align: ['center', 'center', 'center'],
        oddRowBGC: 'rgba(0, 80, 120, 0.2)',
        evenRowBGC: 'rgba(0, 50, 80, 0.1)'
      },

      config4: {
        header: ['排序', '县市区', '产量(万吨)'],
        data: [
          ['1', '湖北省监利县', '18.24'],
          ['2', '湖北省洪湖市', '16.50'],
          ['3', '湖北省潜江市', '15.72'],
          ['4', '江苏省盱眙县', '13.00'],
          ['5', '湖南省南县', '12.05'],
          ['6', '安徽省霍邱县', '9.95'],
          ['7', '湖北省公安县', '9.23'],
          ['8', '湖北省沙洋县', '7.99'],
          ['9', '湖北省石首市', '6.23'],
          ['10', '湖南省沅江市', '6.12'],
          ['11', '湖北省仙桃市', '5.63'],
          ['12', '<span style="color:#ff9966">湖北省黄梅县</span>', '5.55'],
          ['13', '安徽省全椒县', '5.50'],
          ['14', '湖南省华容县', '5.29'],
          ['15', '湖北省汉川市', '4.71'],
          ['16', '湖北省天门市', '4.34'],
          ['17', '江西省永修县', '4.00'],
          ['18', '江苏省泗洪县', '3.80'],
          ['19', '安徽省宿松县', '3.80'],
          ['20', '安徽省定远县', '3.67'],
          ['21', '湖北省钟祥市', '3.56'],
          ['22', '安徽省长丰县', '3.46'],
          ['23', '湖南省君山区', '3.36'],
          ['24', '安徽省庐江县', '3.20'],
          ['25', '湖南省临湘市', '3.03'],
          ['26', '山东省鱼台县', '3.00']
        ],
        rowNum: 8,
        headerHeight: 35,
        align: ['center', 'left', 'center'],
        oddRowBGC: 'rgba(0, 80, 120, 0.2)',
        evenRowBGC: 'rgba(0, 50, 80, 0.1)'
      },

      images: [
        require('@/assets/images/purchase_places/place1.jpg'),
        require('@/assets/images/purchase_places/place2.jpg'),
        require('@/assets/images/purchase_places/place3.jpg'),
        require('@/assets/images/purchase_places/place4.jpg')
        // require('@/assets/images/purchase_places/place5.jpg')
      ],

      activePage: 1,
      // 黄梅县数据
      townData: {
        header: ['序号', '乡镇名称', '农户总数量(家)', '养殖总面积(亩)', '详情'],
        data: [],
        rowNum: 10,
        headerHeight: 45,
        columnWidth: [100],
        oddRowBGC: 'rgba(0, 80, 120, 0.2)',
        evenRowBGC: 'rgba(0, 50, 80, 0.1)'
      },

      loading: false,

      // 某个乡镇数据
      currentTownData: {
        header: ['序号', '村名称', '农户总数量(家)', '养殖总面积(亩)', '详情'],
        data: [],
        rowNum: 10,
        headerHeight: 45,
        columnWidth: [100],
        oddRowBGC: 'rgba(0, 80, 120, 0.2)',
        evenRowBGC: 'rgba(0, 50, 80, 0.1)'
      },
      currentTownTitle: '',
      currentTownList: [], // 存储被点击的乡镇列表

      // 某个乡镇里的某个村数据
      currentVillageData: {
        header: ['序号', '农户姓名', '农户编号', '住址', '养殖面积(亩)'],
        data: [],
        rowNum: 10,
        headerHeight: 45,
        columnWidth: [100],
        oddRowBGC: 'rgba(0, 80, 120, 0.2)',
        evenRowBGC: 'rgba(0, 50, 80, 0.1)'
      },
      currentVillageTitle: ''
    }
  },

  mounted() {
    this.$nextTick(() => {
      if (this.detailType === 'overview') {
        this.initIfNeeded()
      }
    })
  },

  watch: {
    detailType(newVal) {
      if (newVal === 'overview') {
        this.$nextTick(() => {
          this.initIfNeeded()
        })
      }
    },

    townNonghuData: {
      handler() {
        this.initTownCharts()
      },
      deep: true,
      immediate: true
    }
  },

  beforeDestroy() {
    this.chart1Instance && this.chart1Instance.dispose()
    this.chart3Instance && this.chart3Instance.dispose()
  },

  computed: {
    ...mapGetters('dashboard', ['townNonghuData']),

    townTitle() {
      return this.townNonghuData.title || '农户数据统计'
    },

    townList() {
      return this.townNonghuData.nonghu_list || []
    }
  },

  methods: {
    initIfNeeded() {
      if (!this.chart1Instance) this.initChart1()
      if (!this.chart3Instance) this.initChart3()
    },

    initChart1() {
      this.chart1Instance = echarts.init(this.$refs.chart1)
      this.chart1Instance.setOption({
        backgroundColor: 'transparent',
        title: {
          text: '2016—2024年小龙虾养殖面积及增速',
          textStyle: { color: '#baf5fd', fontSize: 13 },
          left: 'center',
          top: 4
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' }
        },
        legend: {
          data: ['养殖面积（万亩）', '增速'],
          textStyle: { color: '#8fb8c8' },
          top: 28
        },
        grid: { left: '12%', right: '12%', bottom: '12%', top: '22%' },
        xAxis: {
          type: 'category',
          data: years,
          axisLabel: { color: '#8fb8c8', fontSize: 11 },
          axisLine: { lineStyle: { color: '#2a5f7a' } }
        },
        yAxis: [
          {
            type: 'value',
            name: '万亩',
            nameTextStyle: { color: '#8fb8c8', fontSize: 11 },
            axisLabel: { color: '#8fb8c8', fontSize: 11 },
            splitLine: { lineStyle: { color: 'rgba(255,255,255,0.08)' } }
          },
          {
            type: 'value',
            name: '增速',
            nameTextStyle: { color: '#E8943A', fontSize: 11 },
            axisLabel: { color: '#E8943A', fontSize: 11, formatter: '{value}%' },
            splitLine: { show: false }
          }
        ],
        series: [
          {
            name: '养殖面积（万亩）',
            type: 'bar',
            data: [900, 1200, 1680, 1929, 2185, 2600, 2800, 2950, 3050],
            itemStyle: { color: '#4A90D9', borderRadius: [3, 3, 0, 0] },
            barMaxWidth: 30,
            label: {
              show: true,
              position: 'top',
              color: '#8fb8c8',
              fontSize: 10
            }
          },
          {
            name: '增速',
            type: 'line',
            yAxisIndex: 1,
            data: [null, 33.33, 40.0, 14.82, 13.27, 18.99, 7.69, 5.36, 3.39],
            lineStyle: { color: '#E8943A', width: 2 },
            itemStyle: { color: '#E8943A' },
            symbol: 'circle',
            symbolSize: 6,
            label: {
              show: true,
              formatter: '{c}%',
              color: '#E8943A',
              fontSize: 10
            }
          }
        ]
      })
    },

    initChart3() {
      this.chart3Instance = echarts.init(this.$refs.chart3)
      this.chart3Instance.setOption({
        backgroundColor: 'transparent',
        title: {
          text: '2016—2024年小龙虾产量及加工占比',
          textStyle: { color: '#baf5fd', fontSize: 13 },
          left: 'center',
          top: 4
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' }
        },
        legend: {
          data: ['产量（万吨）', '加工量（万吨）', '占比'],
          textStyle: { color: '#8fb8c8' },
          top: 28
        },
        grid: { left: '12%', right: '12%', bottom: '12%', top: '22%' },
        xAxis: {
          type: 'category',
          data: years,
          axisLabel: { color: '#8fb8c8', fontSize: 11 },
          axisLine: { lineStyle: { color: '#2a5f7a' } }
        },
        yAxis: [
          {
            type: 'value',
            name: '万吨',
            nameTextStyle: { color: '#8fb8c8', fontSize: 11 },
            axisLabel: { color: '#8fb8c8', fontSize: 11 },
            splitLine: { lineStyle: { color: 'rgba(255,255,255,0.08)' } }
          },
          {
            type: 'value',
            name: '占比',
            min: 0,
            max: 60,
            nameTextStyle: { color: '#5BAD6F', fontSize: 11 },
            axisLabel: { color: '#5BAD6F', fontSize: 11, formatter: '{value}%' },
            splitLine: { show: false }
          }
        ],
        series: [
          {
            name: '产量（万吨）',
            type: 'bar',
            data: [82.71, 112.97, 163.87, 208.96, 239.37, 263.36, 289.07, 316.1, 344.76],
            itemStyle: { color: '#4A90D9', borderRadius: [3, 3, 0, 0] },
            barMaxWidth: 24
          },
          {
            name: '加工量（万吨）',
            type: 'bar',
            data: [19.21, 30.94, 40.9, 50.99, 56.61, 66.18, 121.68, 140.23, 138.37],
            itemStyle: { color: '#E8943A', borderRadius: [3, 3, 0, 0] },
            barMaxWidth: 24
          },
          {
            name: '占比',
            type: 'line',
            yAxisIndex: 1,
            data: [23.23, 27.39, 24.96, 24.4, 23.65, 25.13, 42.1, 44.36, 40.13],
            lineStyle: { color: '#5BAD6F', width: 2 },
            itemStyle: { color: '#5BAD6F' },
            symbol: 'circle',
            symbolSize: 6,
            label: {
              show: true,
              formatter: '{c}%',
              color: '#5BAD6F',
              fontSize: 10
            }
          }
        ]
      })
    },

    initTownCharts() {
      this.loading = true

      this.townData = {
        ...this.townData,
        data: this.townList.map((item, index) => {
          return [
            String(index + 1),
            item.xiang_zhen,
            item.nonghu_number,
            item.size_sum,
            '<i class="el-icon-d-arrow-right" style="font-size:18px;color:#00ffff"></i>'
          ]
        })
      }

      this.loading = false
    },

    // 对农户名称进行处理
    hideNonghuName(name) {
      if (!name) return ''

      const length = name.length

      return name.slice(0, 1) + '*'.repeat(length - 1)
    },

    // 对农户编号进行处理
    hideNonghuCode(code) {
      if (!code) return ''

      const length = code.length

      return code.slice(0, 6) + '*'.repeat(length - 6)
    },

    // 点击详情获取单个镇数据
    async handleClickTown({ rowIndex }) {
      const item = this.townList[rowIndex]
      // console.log(item)
      if (!item) return

      try {
        const res = await getTownData({ name: item.xiang_zhen })
        if (res.resultCode == 1) {
          this.currentTownData = {
            ...this.currentTownData,
            data: res.resultInfo.list.map((item, index) => {
              return [
                String(index + 1),
                item.cun,
                item.nonghu_number,
                item.total_size,
                '<i class="el-icon-d-arrow-right" style="font-size:18px;color:#00ffff"></i>'
              ]
            })
          }
          this.currentTownTitle = res.resultInfo.title
          this.currentTownList = res.resultInfo.list
        }
        // console.log(res)
        this.activePage = 2
      } catch (error) {
        console.log(error)
      }
    },

    // 点击详情获取单个村数据
    async handleClickVillage({ rowIndex }) {
      const item = this.currentTownList[rowIndex]
      // console.log(item)
      if (!item) return

      try {
        const res = await getVillageData({ name: item.cun })
        if (res.resultCode == 1) {
          this.currentVillageData = {
            ...this.currentVillageData,
            data: res.resultInfo.list.map((item, index) => {
              return [
                String(index + 1),
                this.hideNonghuName(item.name),
                this.hideNonghuCode(item.code),
                item.address,
                item.size
              ]
            })
          }
          this.currentVillageTitle = res.resultInfo.title
        }
        // console.log(res)
        this.activePage = 3
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped>
.mapbox {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 16px;
  gap: 12px;
}

.bg-image {
  width: 100%;
  height: 100%;
  background: url('../assets/images/bg_middle_pic3.jpg') no-repeat center center;
  background-size: cover;
  background-position: center;
  border-radius: 12px;
  position: relative;
}

.to-pre,
.to-next {
  flex-shrink: 0;
  align-self: center;
  background: rgba(0, 180, 220, 0.15);
  border: 1px solid #00cfff;
  color: #00cfff;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
}

.chart-area {
  /* display: flex; */
  /* flex-direction: column; */
  /* align-items: center; */
  /* justify-content: center; */
  flex: 1;
  height: 100%;
  width: 100%;
  gap: 8px;
  overflow: hidden;
}

.detail-panel {
  flex: 1;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  padding: 20px 30px;
  box-sizing: border-box;
}

.gathering-content {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 40px;
  width: 100%;
  height: 100%;
  padding: 10px 90px 80px;
  align-items: center;
}

.img-item {
  flex-shrink: 0;
  width: 47%;
  height: 45%;
  object-fit: fill;
  border-radius: 8px;
}

.gathering-card {
  border: 1px solid rgba(0, 207, 255, 0.35);
  background: rgba(0, 80, 120, 0.2);
  border-radius: 10px;
  padding: 16px 18px;
}

.gathering-title {
  color: #baf5fd;
  font-size: 18px;
  margin-bottom: 8px;
}

.gathering-text {
  color: #8fb8c8;
  font-size: 14px;
  line-height: 1.6;
}

.btns {
  display: flex;
  justify-content: space-between;
}

.goback {
  color: #83ffe1;
  cursor: pointer;
  margin: 0 15px;
}

.closebtn {
  color: #83ffe1;
  text-align: right;
  margin: 0 15px;
  cursor: pointer;
}

.header {
  color: white;
  font-size: 28px;
  text-align: center;
  margin-top: -20px;
  margin-bottom: 20px;
  font-weight: 600;
}

.chart {
  height: 50%;
  width: 48%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chart-items {
  height: 88%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;

  /* datav 表格样式覆盖 */
  :deep(.dv-scroll-board .header) {
    background-color: rgba(0, 133, 183, 0.45) !important;
    border-radius: 6px;
    height: 35px;
  }

  :deep(.dv-scroll-board .header .header-item) {
    color: #baf5fd !important;
    font-size: 16px !important;
    text-align: center !important;
    line-height: 35px !important;
    height: 35px !important;
  }

  :deep(.dv-scroll-board .rows .ceil) {
    font-size: 14px !important;
    color: #7ee8f5 !important;
    text-align: center !important;
  }

  :deep(.dv-scroll-board .rows .row-item) {
    border-bottom: 1px solid rgba(0, 180, 220, 0.08);
  }
}

/* 表格容器 */
.table-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 8px 10px;
  box-sizing: border-box;
}

.table-title {
  color: #baf5fd;
  font-size: 12px;
  text-align: center;
  padding-bottom: 8px;
  flex-shrink: 0;
  opacity: 0.85;
}

.farmer-content {
  width: 100%;
  height: calc(100% - 60px);
  padding: 8px 80px 15px;
  box-sizing: border-box;
  overflow: hidden;
}

.farmer-table {
  width: 100%;
  height: 100%;
}

.farmer-table :deep(.header) {
  background-color: rgba(1, 55, 90, 0.85) !important;
  border-radius: 6px;
  font-size: 20px;
  line-height: 45px !important;
}

.farmer-table :deep(.header .header-item) {
  color: #b8f1ff !important;
  font-size: 20px !important;
  text-align: center !important;
  line-height: 45px !important;
  height: 45px !important;
}

.farmer-table :deep(.rows .ceil) {
  font-size: 18px !important;
  color: #7ee8f5 !important;
  text-align: center !important;
}

.farmer-table :deep(.rows .row-item) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
</style>
